const styles = () => ({
  icon: {
    width: 437,
    height: 454,
  },
});

export default styles;
